<div class="container-fluid sell_dash">
  <div class="wrapper">
      <div class="row">
        <app-sidemenu></app-sidemenu> 
        <section class="right">
            <app-sellheader></app-sellheader>
            <div class="right-middle row justify-content-center">
              <div class="adminActions">
                <input type="checkbox" name="adminToggle" class="adminToggle" />
                <a class="adminButton" href="#!"><i class="fas fa-pen"></i></a>
                <div class="adminButtons">
                  <a href="#" title="Show Data"><i class="far fa-chart-bar"></i></a>
                  <a href="#" title="quote"><i class="fas fa-quote-right"></i></a>
                  <a href="#" title="Publish"><i class="fas fa-upload"></i></a>
                  <a href="#" title="Add file"><i class="fas fa-paperclip"></i></a>
                </div>
              </div>
              <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10" id="top-nav" >
                <div class="row">
                  <div class="col-sm-12 col-lg-12">
                    <div class="container-fluid">
                      <div>
                        <div class="search-form-box top-search" >
                          <div class="input-group" >
                            <div class="dropdown" id="filter">
                              <div class="select">
                                <span>Categories</span>
                                <i class="fa fa-chevron-left"></i>
                              </div>
                              <!-- <input type="hidden" name="Filter" id="filter" /> -->
                              <ul class="dropdown-menu domain_name_filter">
                                <li value="Data">Data</li>
                                <li value="Algorithm">Algorithm</li>
                                <li value="Engine">Engine</li>
                                <li value="Solution">Solution</li>
                              </ul>
                            </div>
                            <form class="form-control h100 s-form" name="s-form2">
                            <input
                              type="text"
                              name="q"
                              class="form-control click-me h100"
                              placeholder="Search Assets...."
                              autocomplete="off"
                              autofocus
                              id="in"
                              
                            >
                            <button
                            type="button"
                            class="btn btn-primary search-btn"
                            
                          >
                          <i class="fas fa-microphone"></i>
                          </button>
                          </form>
                          <!-- <p class="info"></p> -->
                            <!-- <ul class="drop-menu text-left suggestion-search-menu add-scroll">
                              <li>
                                <a href="#" class="suggestion-anchor">
                                  <div class="sleft">
                                    <div class="media">
                                      <div class="s-tag">
                                        4.3
                                      </div>
                                      <div class="media-body">
                                        <h5>B.Tech Computer Science</h5>
                                        <p>Gautam Buddha University</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="sright">
                                    <h5>Greater NoidaUttar Pradesh</h5>
                                    <p>Gautam Buddha University</p>
                                  </div>
                                </a>
                              </li>
                              <li>
                                <a href="#" class="suggestion-anchor">
                                  <div class="sleft">
                                    <div class="media">
                                      <div class="s-tag">
                                        4.3
                                      </div>
                                      <div class="media-body">
                                        <h5>B.Tech Computer Science</h5>
                                        <p>Gautam Buddha University</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="sright">
                                    <h5>Greater NoidaUttar Pradesh</h5>
                                    <p>Gautam Buddha University</p>
                                  </div>
                                </a>
                              </li>
                              <li>
                                <a href="#" class="suggestion-anchor">
                                  <div class="sleft">
                                    <div class="media">
                                      <div class="s-tag">
                                        4.3
                                      </div>
                                      <div class="media-body">
                                        <h5>B.Tech Computer Science</h5>
                                        <p>Gautam Buddha University</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="sright">
                                    <h5>Greater NoidaUttar Pradesh</h5>
                                    <p>Gautam Buddha University</p>
                                  </div>
                                </a>
                              </li>
                            </ul> -->
                            <div class="filterdrop" id="filter" >
                              <div class="select">
                                <i class="fas fa-filter">&nbsp;&nbsp;<span class="filter-text">Filters</span></i>
                              </div>
                              <ul class="dropdown-menu">
                                <li (click)="type()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;   Type</li>
                                <li [hidden]="istype" class="filter"><label class="filter-container">Raw
                                 <input type="checkbox" name="type" value="Raw">
                                 <span class="checkmark"></span>
                               </label></li>
                                <li [hidden]="istype" class="filter"><label class="filter-container">Transformed
                                 <input type="checkbox" name="type" value="Transformed">
                                 <span class="checkmark"></span>
                               </label></li>
                                <!-- <li [hidden]="istype" class="filter"><label class="filter-container">One
                                 <input type="checkbox" name="type" value="three">
                                 <span class="checkmark"></span>
                               </label></li> -->
                                <li (click)="price()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;  Price</li>
                                <li [hidden]="isprice" class="filter"><label class="filter-container">$0-$500
                                 <input type="checkbox" name="price" id="lowtohigh" value="100">
                                 <span class="checkmark"></span>
                               </label></li>
                                <li [hidden]="isprice" class="filter"><label class="filter-container">$500-$1000
                                 <input type="checkbox" name="price" id="hightoLow" value="700">
                                 <span class="checkmark"></span>
                               </label></li>
                               <li [hidden]="isprice" class="filter"><label class="filter-container">>$1000
                                <input type="checkbox" name="price" id="hightoLow" value="1200">
                                <span class="checkmark"></span>
                              </label></li>
                                <li (click)="category()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;  Category</li>
                                <li [hidden]="iscategory" class="filter"><label class="filter-container">Data
                                 <input type="checkbox" name="category" value="Data">
                                 <span class="checkmark"></span>
                               </label></li>
                                <li [hidden]="iscategory" class="filter"><label class="filter-container">Algorithm
                                 <input type="checkbox" name="category" value="Algorithm">
                                 <span class="checkmark"></span>
                               </label></li>
                                <li [hidden]="iscategory" class="filter"><label class="filter-container">Engine
                                 <input type="checkbox" name="category" value="Engine">
                                 <span class="checkmark"></span>
                               </label></li>
                               <li [hidden]="iscategory" class="filter"><label class="filter-container">Solution
                                <input type="checkbox" name="category" value="Solution">
                                <span class="checkmark"></span>
                              </label></li>
                                <li (click)="classify()"><i class="fas fa-plus" style="color: white;"></i>&nbsp;  Classification</li>
                                <li [hidden]="isclassify" class="filter"><label class="filter-container">Sensitive
                                 <input type="checkbox" name="classification" value="Sensitive">   
                                 <span class="checkmark"></span>
                               </label></li>
                                <li [hidden]="isclassify" class="filter"><label class="filter-container">Confidential
                                 <input type="checkbox" name="classification" value="Confidential">
                                 <span class="checkmark"></span>
                               </label></li>
                                <li [hidden]="isclassify" class="filter"><label class="filter-container">Public
                                 <input type="checkbox" name="classification" value="Public">
                                 <span class="checkmark"></span>
                               </label></li>
                               <li (click)="removefilter()" id="clearfilter">Clear Filters</li>
                              </ul>
                            </div>
                            <div class="btn cart-btn" routerLink="/addcart">
                              <i class="fas fa-shopping-cart"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 applyfilter" id="domain" >
                <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" >
                  <!-- Indicators -->
                  <ol class="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                    <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                  </ol>
                  <!-- Wrapper for slides -->
                  <div class="carousel-inner" style="height: 70vh;">
                    <div class="carousel-item active" style="background-image: url(assets/image/blog1.jpg); background-position: center; background-size: cover; height: 70vh; background-color: #000000; opacity: 0.8;">
                      <div class="d-block w-100 carousel-info" >
                        <h1 class="carousel-head">Buy Asset</h1>
                        <h1 class="carousel-head">For Your Use-Case</h1>
                      </div>
                    </div>
                    <div class="carousel-item" style="background-image: url(assets/image/blueprint.jpeg); background-position: center; background-size: cover; height: 70vh;">
                      <div class="d-block w-100 carousel-info" >
                        <h1 class="carousel-head">Pay Now</h1>
                        <h1 class="carousel-head">Earn Rights</h1>
                      </div>
                    </div>
                    <div class="carousel-item" style="background-image: url(assets/image/problem_3.jpeg); background-position: center; background-size: cover; height: 70vh;">
                      <div class="d-block w-100 carousel-info" >
                       <h1 class="carousel-head">Accelerate</h1>
                       <h1 class="carousel-head">Your Innovation</h1>
                     </div>
                   </div>
                  </div>
                  <!-- Controls -->
                  <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
                </a>
                  <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
                </a>
                </div>
              </div>
              <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 applyfilter" id="domain" >
        <div class="ex2">
          <h1>We can help you in accelerating your innovation in more than 15 domains</h1>
        </div>
      </div>
              <div class="col-md-10 col-lg-8 col-xl-11 col-10 col-sm-10 applyfilter" >
                  <div class="wrapper">
                  <div class="row">
                      <div class="col-sm col-lg-6 col2" >
                        <div class="row">
                           <div class="col-md-12 col2">
                            <div class="outer-div" (mouseenter)="hovercard($event)" (mouseleave)="hovercard2($event)">
                              <div class="inner-div" style="background-image: url(assets/image/health.jpg);"></div>
                                <div class="info" style="padding-top: 50%; padding-left: 12%;">
                                  <div class="info_heading">
                                      <h2>HealthCare</h2>
                                      <p>Purchase Now</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <div class="row rowmargin" >
                              <div class="col-sm col-lg-6 col2" >
                                  <div class="outer-div" (mouseenter)="hovercard($event)" (mouseleave)="hovercard2($event)" style="height: 200px;">
                                      <div class="inner-div" style="background-image: url(assets/image/p_environ.jpeg);"></div>
                                      <div class="info" >
                                          <div class="info_heading">
                                              <h2>Environment</h2>
                                              <p>Purchase Now</p>
                                          </div>
                                           
                                       </div>
                                  </div>
                              </div>
                              <div class="col-sm col-lg-6 col2">
                                  <div class="outer-div" (mouseenter)="hovercard($event)" (mouseleave)="hovercard2($event)" style="height: 200px;">
                                      <div class="inner-div" style="background-image: url(assets/image/p_power.jpeg);"></div>
                                      <div class="info" >
                                          <div class="info_heading">
                                              <h2>Power Sector</h2>
                                              <p>Purchase Now</p>
                                          </div>
                                           
                                       </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-sm col-lg-6 col2">
                          <div class="row">
                              <div class="col-md-12 col2" >
                                  <div class="outer-div" (mouseenter)="hovercard($event)" (mouseleave)="hovercard2($event)" style="height: 195px;">
                                      <div class="inner-div" style="background-image: url(assets/image/finance.jpeg);"></div>
                                      <div class="info" style="padding-top:15%; padding-left: 12%;">
                                          <div class="info_heading">
                                              <h2>Banking, Finance & Insurance</h2>
                                              <p>Purchase Now</p>
                                          </div>
                                           
                                       </div>
                                  </div>
                              </div>
                          </div>
                          <div class="row rowmargin">
                              <div class="col-sm col-lg-6 col2" >
                                  <div class="outer-div" (mouseenter)="hovercard($event)" (mouseleave)="hovercard2($event)" style="height: 195px;">
                                      <div class="inner-div" style="background-image: url(assets/image/testtechnology.jpeg);"></div>
                                      <div class="info" >
                                          <div class="info_heading">
                                              <h2>Technology</h2>
                                              <p>Purchase Now</p>
                                          </div>
                                           
                                       </div>
                                  </div>
                              </div>
                              <div class="col-sm col-lg-6 col2">
                                  <div class="outer-div" (mouseenter)="hovercard($event)" (mouseleave)="hovercard2($event)" style="height: 195px;">
                                      <div class="inner-div" style="background-image: url(assets/image/energy.jpeg);"></div>
                                      <div class="info">
                                          <div class="info_heading">
                                              <h2>Energy</h2>
                                              <p>Purchase Now</p>
                                          </div>
                                           
                                       </div>
                                  </div>
                              </div>
                          </div>
                          <div class="row rowmargin" >
                              <div class="col-md-12 col2" >
                                  <div class="outer-div" (mouseenter)="hovercard($event)" (mouseleave)="hovercard2($event)" style="height: 200px;">
                                      <div class="inner-div" style="background-image: url(assets/image/education.jpeg);"></div>
                                      <div class="info" style="padding-top:15%; padding-left: 12%;">
                                          <div class="info_heading">
                                              <h2>Education</h2>
                                              <p>Purchase Now</p>
                                          </div>
                                           
                                       </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              </div>
              <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 purchase_cards" id="domain" >

                <h3>Recommended For You</h3>
                <div class="menu-wrapper ">
                 <ul class="menu disable-scrollbars" style="margin-bottom: 0px;">
                   
                     <li class="item">
                      <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
                        <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_health.jpg);  --my-color-var: linear-gradient(to bottom,rgba(0,0,0,0),#ff5433 100%);" >
                          <img class="premium" src="../../../assets/image/Data.png">
                          <div class="card-category">
                            <img src="../../../assets/image/healthcare2.png" style="margin-left: 4%;">
                            <p>HealthCare</p>
                          </div>
                        </div>
                        <div class="card-body">
                          <p><a type="button" (click)="onClick($event)">Show Details</a></p>
                          <span>Healthcare</span>,&nbsp;<span>CT-Scans</span>
                          <div class="row title-price">
                           <div class="col-sm-8 title">
                             <div class="product-title">Full Body CT-Scans with detailed radiologist report </div>
                             <div class='tooltip'>
                             Full Body CT-Scans with detailed radiologist report 
                              </div>
                           </div>
                           <div class="col-sm-4 price">
                            <h4 >$ 200</h4>
                           </div>
                          </div>
                         <div class="row">
                           <div class="col-sm-4 info-row">
                             <img src="../../../assets/image/Confidential.png">
                             <p>Confidential</p>
                           </div>
                           <div class="col-sm-4 info-row">
                             <img src="../../../assets/image/Raw.png">
                            <p>Raw</p>
                           </div>
                           <div class="col-sm-4 info-row">
                             <img src="../../../assets/image/Data Stamping.png">
                             <p>Simplified</p>
                           </div>
                         </div>
                          
                        </div>
                        <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
                      </div>
                      
                    </li><!--
             --><li class="item">                            
              <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
                <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_finance.jpg); --my-color-var: linear-gradient(to bottom,#fbd3e9, #bb377d);" >
                  <img class="premium" src="../../../assets/image/Data.png">
                  <div class="card-category">
                    <img src="../../../assets/image/testicon_finance.png">
                    <p>Finance</p>
                  </div>
                </div>
                <div class="card-body">
                  <p><a type="button" (click)="onClick1($event)">Show Details</a></p>
                  <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                  <div class="row title-price">
                   <div class="col-sm-8 title">
                     <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                             <div class='tooltip'>
                              This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                              </div>
                   </div>
                   <div class="col-sm-4 price">
                    <h4 >$ 1.119</h4>
                   </div>
                  </div>
                 <div class="row">
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Confidential.png">
                     <p>Confidential</p>
                   </div>
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Raw.png">
                    <p>Raw</p>
                   </div>
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Data Stamping.png">
                     <p>Simplified</p>
                   </div>
                 </div>
                  
                </div>
                <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
              </div>
               </li><!--
             --><li class="item">
              <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
                <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_energy.jpg); --my-color-var: linear-gradient(to top, #c9ffbf, #ffafbd);" >
                  <img class="premium" src="../../../assets/image/Data.png">
                  <div class="card-category">
                    <img src="../../../assets/image/testicon_energy.png">
                    <p>Energy</p>
                  </div>
                </div>
                <div class="card-body">
                  <p><a type="button" (click)="onClick2($event)">Show Details</a></p>
                  <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                  <div class="row title-price">
                   <div class="col-sm-8 title">
                     <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                             <div class='tooltip'>
                              This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                              </div>
                   </div>
                   <div class="col-sm-4 price">
                    <h4 >$ 1.119</h4>
                   </div>
                  </div>
                 <div class="row">
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Confidential.png">
                     <p>Confidential</p>
                   </div>
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Raw.png">
                    <p>Raw</p>
                   </div>
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Data Stamping.png">
                     <p>Simplified</p>
                   </div>
                 </div>
                  
                </div>
                <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
              </div>
                               
            </li><!--
             --><li class="item">
              <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
                <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_realestate.jpg); --my-color-var: linear-gradient(to top, #b993d6, #8ca6db);" >
                  <img class="premium" src="../../../assets/image/Data.png">
                  <div class="card-category">
                    <img src="../../../assets/image/testicon_realestate.png" style="margin-left: 4%;">
                    <p>Real Estate</p>
                  </div>
                </div>
                <div class="card-body">
                  <p><a type="button" (click)="onClick3($event)">Show Details</a></p>
                  <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                  <div class="row title-price">
                   <div class="col-sm-8 title">
                     <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                             <div class='tooltip'>
                              This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                              </div>
                   </div>
                   <div class="col-sm-4 price">
                    <h4 >$ 1.119</h4>
                   </div>
                  </div>
                 <div class="row">
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Confidential.png">
                     <p>Confidential</p>
                   </div>
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Raw.png">
                    <p>Raw</p>
                   </div>
                   <div class="col-sm-4 info-row">
                     <img src="../../../assets/image/Data Stamping.png">
                     <p>Simplified</p>
                   </div>
                 </div>
                  
                </div>
                <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
              </div>
                              
             </li>
                 </ul>
             
                 <div class="paddles">
                     
                  <img class="left-paddle paddle" src="../../../assets/image/return.png">
                   
                  <img class="right-paddle paddle " src="../../../assets/image/right-arrow.png">
                 </div>
             
             </div>
             </div>
             <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 purchase_cards" id="domain2">
              <h3>Trending Now</h3>
              <div class="menu-wrapper ">
               <ul class="menu2 disable-scrollbars" style="margin-bottom: 0px;">
                   <li class="item">
                    <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
                      <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_realestate.jpg); --my-color-var: linear-gradient(to bottom, #f857a6, #ff5858);" >
                        <img class="premium" src="../../../assets/image/Data.png">
                        <div class="card-category">
                          <img src="../../../assets/image/testicon_realestate.png" style="margin-left: 4%;">
                          <p>Real Estate</p>
                        </div>
                      </div>
                      <div class="card-body">
                        <p><a type="button" (click)="onClick4($event)">Show Details</a></p>
                        <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                        <div class="row title-price">
                         <div class="col-sm-8 title">
                           <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                           <div class='tooltip'>
                            This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                            </div>
                         </div>
                         <div class="col-sm-4 price">
                          <h4 >$ 1.119</h4>
                         </div>
                        </div>
                       <div class="row">
                         <div class="col-sm-4 info-row">
                           <img src="../../../assets/image/Confidential.png">
                           <p>Confidential</p>
                         </div>
                         <div class="col-sm-4 info-row">
                           <img src="../../../assets/image/Raw.png">
                          <p>Raw</p>
                         </div>
                         <div class="col-sm-4 info-row">
                           <img src="../../../assets/image/Confidential.png">
                           <p>Simplified</p>
                         </div>
                       </div>
                        
                      </div>
                      <div class="card-footer">
                        <div class="row wrapper">
                          <button class="btn col-sm-3 col-lg-3 downprev">
                            <div class="dv1">
                              <img src="../../../assets/image/Download.png">
                            </div>
                          </button>
                          <button class="btn col-sm-3 col-lg-3 adcart">
                            <div class="dv1">
                              <img src="../../../assets/image/AddtoCart.png">
                            </div>
                          </button>
                          <button class="btn col-sm-3 col-lg-3 shwdetail">
                            <div class="dv1">
                              <img src="../../../assets/image/Quickview.png">
                            </div>
                          </button>
                        </div>
                       </div>
                    </div>
                    </li><!--
           --><li class="item">                            
            <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
              <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_education.jpg);  --my-color-var: linear-gradient(to top, #1cd8d2, #93edc7)" >
                <img class="premium" src="../../../assets/image/Data.png">
                <div class="card-category">
                  <img src="../../../assets/image/testicon_education.png">
                  <p>Education</p>
                </div>
              </div>
              <div class="card-body">
                <p><a type="button" (click)="onClick5($event)">Show Details</a></p>
                <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                <div class="row title-price">
                 <div class="col-sm-8 title">
                   <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                           <div class='tooltip'>
                            This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                            </div>
                 </div>
                 <div class="col-sm-4 price">
                  <h4 >$ 1.119</h4>
                 </div>
                </div>
               <div class="row">
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Confidential.png">
                   <p>Confidential</p>
                 </div>
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Raw.png">
                  <p>Raw</p>
                 </div>
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Confidential.png">
                   <p>Simplified</p>
                 </div>
               </div>
                
              </div>
              <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
            </div>
                       </li><!--
           --><li class="item">
            <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
              <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_finance.jpg); --my-color-var: linear-gradient(to bottom, #7474bf, #348ac7)" >
                <img class="premium" src="../../../assets/image/Data.png">
                <div class="card-category">
                  <img src="../../../assets/image/testicon_finance.png">
                  <p>Finance</p>
                </div>
              </div>
              <div class="card-body">
                <p><a type="button" (click)="onClick6($event)">Show Details</a></p>
                <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                <div class="row title-price">
                 <div class="col-sm-8 title">
                   <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                           <div class='tooltip'>
                            This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                            </div>
                 </div>
                 <div class="col-sm-4 price">
                  <h4 >$ 1.119</h4>
                 </div>
                </div>
               <div class="row">
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Confidential.png">
                   <p>Confidential</p>
                 </div>
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Raw.png">
                  <p>Raw</p>
                 </div>
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Confidential.png">
                   <p>Simplified</p>
                 </div>
               </div>
                
              </div>
              <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
            </div>
              
             </li><!--
           --><li class="item">
            <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
              <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_energy.jpg); --my-color-var: linear-gradient(to top, #eb3349, #f45c43)" >
                <img class="premium" src="../../../assets/image/Data.png">
                <div class="card-category">
                  <img src="../../../assets/image/testicon_energy.png" style="margin-left: 4%;">
                  <p>Energy</p>
                </div>
              </div>
              <div class="card-body">
                <p><a type="button" (click)="onClick7($event)">Show Details</a></p>
                <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                <div class="row title-price">
                 <div class="col-sm-8 title">
                   <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                           <div class='tooltip'>
                            This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                            </div>
                 </div>
                 <div class="col-sm-4 price">
                  <h4 >$ 1.119</h4>
                 </div>
                </div>
               <div class="row">
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Confidential.png">
                   <p>Confidential</p>
                 </div>
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Raw.png">
                  <p>Raw</p>
                 </div>
                 <div class="col-sm-4 info-row">
                   <img src="../../../assets/image/Confidential.png">
                   <p>Simplified</p>
                 </div>
               </div>
                
              </div>
              <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
            </div>
                          
           </li>
               </ul>
           
               <div class="paddles">
                   
                <img class="left-paddle2 paddle" src="../../../assets/image/return.png">
                 
                <img class="right-paddle2 paddle " src="../../../assets/image/right-arrow.png">
               </div>
           
           </div>
           </div>
           <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 purchase_cards" id="domain2">
            <h3>Assorted Picks</h3>
            <div class="menu-wrapper ">
             <ul class="menu3 disable-scrollbars" style="margin-bottom: 0px;">
                 <li class="item">
                  <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
                    <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_realestate.jpg); --my-color-var: linear-gradient(to top, #1d976c, #93f9b9)" >
                      <img class="premium" src="../../../assets/image/Data.png">
                      <div class="card-category">
                        <img src="../../../assets/image/testicon_realestate.png" style="margin-left: 4%;">
                        <p>Real Estate</p>
                      </div>
                    </div>
                    <div class="card-body">
                      <p><a type="button" (click)="onClick4($event)">Show Details</a></p>
                      <span>MRI</span>,&nbsp;<span>CT-Scan</span>
                      <div class="row title-price">
                       <div class="col-sm-8 title">
                         <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                         <div class='tooltip'>
                          This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                          </div>
                       </div>
                       <div class="col-sm-4 price">
                        <h4 >$ 1.119</h4>
                       </div>
                      </div>
                     <div class="row">
                       <div class="col-sm-4 info-row">
                         <img src="../../../assets/image/Confidential.png">
                         <p>Confidential</p>
                       </div>
                       <div class="col-sm-4 info-row">
                         <img src="../../../assets/image/Raw.png">
                        <p>Raw</p>
                       </div>
                       <div class="col-sm-4 info-row">
                         <img src="../../../assets/image/Confidential.png">
                         <p>Simplified</p>
                       </div>
                     </div>
                      
                    </div>
                    <div class="card-footer">
                      <div class="row wrapper">
                        <button class="btn col-sm-3 col-lg-3 downprev">
                          <div class="dv1">
                            <img src="../../../assets/image/Download.png">
                          </div>
                        </button>
                        <button class="btn col-sm-3 col-lg-3 adcart">
                          <div class="dv1">
                            <img src="../../../assets/image/AddtoCart.png">
                          </div>
                        </button>
                        <button class="btn col-sm-3 col-lg-3 shwdetail">
                          <div class="dv1">
                            <img src="../../../assets/image/Quickview.png">
                          </div>
                        </button>
                      </div>
                     </div>
                  </div>
                  </li><!--
         --><li class="item">                            
          <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
            <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_education.jpg); --my-color-var: linear-gradient(to bottom, #ffe259, #ffa751)" >
              <img class="premium" src="../../../assets/image/Data.png">
              <div class="card-category">
                <img src="../../../assets/image/testicon_education.png">
                <p>Education</p>
              </div>
            </div>
            <div class="card-body">
              <p><a type="button" (click)="onClick5($event)">Show Details</a></p>
              <span>MRI</span>,&nbsp;<span>CT-Scan</span>
              <div class="row title-price">
               <div class="col-sm-8 title">
                 <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                         <div class='tooltip'>
                          This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                          </div>
               </div>
               <div class="col-sm-4 price">
                <h4 >$ 1.119</h4>
               </div>
              </div>
             <div class="row">
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Confidential.png">
                 <p>Confidential</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Raw.png">
                <p>Raw</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Data Stamping.png">
                 <p>Simplified</p>
               </div>
             </div>
              
            </div>
           <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
          </div>
                     </li><!--
         --><li class="item">
          <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
            <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_finance.jpg); --my-color-var: linear-gradient(to left, #e55d87, #5fc3e4)" >
              <img class="premium" src="../../../assets/image/Data.png">
              <div class="card-category">
                <img src="../../../assets/image/testicon_finance.png">
                <p>Finance</p>
              </div>
            </div>
            <div class="card-body">
              <p><a type="button" (click)="onClick6($event)">Show Details</a></p>
              <span>MRI</span>,&nbsp;<span>CT-Scan</span>
              <div class="row title-price">
               <div class="col-sm-8 title">
                 <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                         <div class='tooltip'>
                          This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                          </div>
               </div>
               <div class="col-sm-4 price">
                <h4 >$ 1.119</h4>
               </div>
              </div>
             <div class="row">
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Confidential.png">
                 <p>Confidential</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Raw.png">
                <p>Raw</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Data Stamping.png">
                 <p>Simplified</p>
               </div>
             </div>
              
            </div>
           <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
          </div>
            
           </li><!--
         --><li class="item">
          <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)" >
            <div class="card-img-top" style="background-image: url(../../../assets/image/testimage_energy.jpg); --my-color-var: linear-gradient(to top, #ec008c, #fc6767)" >
              <img class="premium" src="../../../assets/image/Data.png">
              <div class="card-category">
                <img src="../../../assets/image/testicon_energy.png" style="margin-left: 4%;">
                <p>Energy</p>
              </div>
            </div>
            <div class="card-body">
              <p><a type="button" (click)="onClick7($event)">Show Details</a></p>
              <span>MRI</span>,&nbsp;<span>CT-Scan</span>
              <div class="row title-price">
               <div class="col-sm-8 title">
                 <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                         <div class='tooltip'>
                          This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                          </div>
               </div>
               <div class="col-sm-4 price">
                <h4 >$ 1.119</h4>
               </div>
              </div>
             <div class="row">
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Confidential.png">
                 <p>Confidential</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Raw.png">
                <p>Raw</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Data Stamping.png">
                 <p>Simplified</p>
               </div>
             </div>
              
            </div>
           <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
          </div>
                        
         </li>
             </ul>
         
             <div class="paddles">
                 
              <img class="left-paddle3 paddle" src="../../../assets/image/return.png">
               
              <img class="right-paddle3 paddle " src="../../../assets/image/right-arrow.png">
             </div>
         
         </div>
         </div>
      <div class="col-md-12 col-lg-10 col-xl-11 col-10 col-sm-10 applyfilter" id="domain" >
        <div class="ex2">
          <h1>Style is a way to say who you are without saying anything at all.</h1>
        </div>
      </div>
      <div class="col-md-10 col-lg-8 col-xl-11 col-10 col-sm-10 rowmargin plussign applyfilter" >
        <img width="950" height="400" src="../../../assets/image/testtechnology.jpeg" alt=""  sizes="(max-width: 1200px) 100vw, 1400px">
        <div class="tool" style="top: 55.543%; left: 11.15574%;  position: absolute;">
          <img class="tooltip-image" src="../../../assets/image/plus.png">
          <div class="tooltip" data-tooltip-position="bottom" data-tooltip-func="hover"> 
            <div class="inner">
              <h5 style="color: #227bf7;">Ultra Durable Frame</h5>
              <p>Salient grade carbon w/ frame protection can take whatever you through at it</p></div>
          </div>
    </div>
    <div class="tool" style="    top: 40.6484%; left: 39.9662%;  position: absolute;">
          <img class="tooltip-image" src="../../../assets/image/plus.png">
          <div class="tooltip" data-tooltip-position="bottom" data-tooltip-func="hover"> 
            <div class="inner">
              <h5 style="color: #227bf7;">Ultra Durable Frame</h5>
              <p>Salient grade carbon w/ frame protection can take whatever you through at it</p></div>
          </div>
    </div>
    <div class="tool" style="    top: 15.01852%; left: 54.2392%;  position: absolute;">
          <img class="tooltip-image" src="../../../assets/image/plus.png">
          <div class="tooltip" data-tooltip-position="bottom" data-tooltip-func="hover"> 
            <div class="inner">
              <h5 style="color: #227bf7;">Ultra Durable Frame</h5>
              <p>Salient grade carbon w/ frame protection can take whatever you through at it</p></div>
          </div>
    </div>
    <div class="tool" style="top: 60.8756%; left: 70.7889%;  position: absolute;">
          <img class="tooltip-image" src="../../../assets/image/plus.png">
          <div class="tooltip" data-tooltip-position="bottom" data-tooltip-func="hover"> 
            <div class="inner">
              <h5 style="color: #227bf7;">Ultra Durable Frame</h5>
              <p>Salient grade carbon w/ frame protection can take whatever you through at it</p></div>
          </div>
    </div>
 
      </div>

      
      <div class="col-md-12 col-lg-12 col-xl-12 col-12 col-sm-12 rowmargin" id="filtersblock">
        <div id="Container" class="container" *ngIf="filters_value.length>0">
          <div class="row offset-lg-5 pt-5 offset-sm-10 offset-md-5 offset-3" *ngIf="loader">
              <img src="./assets/image/Diamond.gif" class="loader_filter mt-5">
            </div>
         <div class="mix" *ngFor="let filters_values of filters_value | paginate: {itemsPerPage:3,currentPage: p}">
            <div class="card" (mouseenter)="purchasehovercard($event)" (mouseleave)="purchasehovercard2($event)">
            <div class="card-img-top {{filters_values['category']}}" style="background-image: url(../../../assets/image/testimage_health.jpg);  --my-color-var: linear-gradient(to left, #ff6e7f, #bfe9ff)" >
              <img class="premium" src="../../../assets/image/{{filters_values['category']}}.png">
              <div class="card-category">
                <img src="../../../assets/image/healthcare2.png" style="margin-left: 4%;">
                <p>HeathCare</p>
              </div>
            </div>
            <div class="card-body">
              <p><a type="button" (click)="onClick($event)">Show Details</a></p>
              <span>MRI</span>,&nbsp;<span>CT-Scan</span>
              <div class="row title-price">
               <div class="col-sm-8 title">
                 <div class="product-title">This is an example of a multi-line ellipsis. We just set the number of lines we want to display before </div>
                 <div class='tooltip'>
                  This is an example of a multi-line ellipsis. We just set the number of lines we want to display before
                  </div>
               </div>
               <div class="col-sm-4 price">
                <h4 >$ {{filters_values['price']}}</h4>
               </div>
              </div>
             <div class="row">
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/{{filters_values['classification']}}.png">
                 <p>{{filters_values['classification']}}</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/{{filters_values['type']}}.png">
                <p>{{filters_values['type']}}</p>
               </div>
               <div class="col-sm-4 info-row">
                 <img src="../../../assets/image/Data Stamping.png">
                 <p>Simplified</p>
               </div>
             </div>
              
            </div>
           <div class="card-footer">
                          <div class="row wrapper">
                            <button class="btn col-sm-3 col-lg-3 downprev">
                              <div class="dv1">
                                <img src="../../../assets/image/Download.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 adcart">
                              <div class="dv1">
                                <img src="../../../assets/image/AddtoCart.png">
                              </div>
                            </button>
                            <button class="btn col-sm-3 col-lg-3 shwdetail">
                              <div class="dv1">
                                <img src="../../../assets/image/Quickview.png">
                              </div>
                            </button>
                          </div>
                         </div>
          </div>
          </div>
          <div class="gap"></div>
          <div class="gap"></div>
        </div>
         <div class="offset-lg-5 offset-xl-5 my-5" *ngIf="filters_value.length==0">
          <h5>No Result Found</h5>
        </div>
       </div>
       <pagination-controls (pageChange)="p = $event" class="mt-4 paginate" *ngIf="filters_value.length>0"></pagination-controls>
       
              <div class="col-md-10 col-lg-8 col-xl-11 col-10 col-sm-10 rowmargin applyfilter" >
                  <div class="row margin purchase-salient">
                      <div class="row">
                      <div class="col-8 ex5">
                          <h2>Sign Up Today & Start Sending Money.</h2>
                          <p>Get 30 days free when you sign up now.</p>
                      </div>
                      <div class="col-4 ex4">
                           <div class="button-4">
                                <div class="eff-4"></div>
                                  <a href="#"> Sign Up Now </a>
                                </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>         
    </div>
  </div>
</div>
    


<!--Modal starts-->
<div class="modal fade detailmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="height: fit-content; width: fit-content;">
    <div class="modal-content">
      <a href="" class="modal__close demo-close" data-target="detailmodal" data-dismiss="modal">
        <i class="far fa-times-circle"></i>
      </a>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-5 left-side" style="padding-right: 0px;">
            <div id="slider-wrap" class="slider-wrap">
              <ul id="slider" class="slider">
                 <li>
                   <img src="assets/image/t-shirt.jpg">
                 </li>
                 
                 <li>
                  <img src="assets/image/woman.jpg">
                 </li>
                 
                 
              </ul>
              
               <!--controls-->
              <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
              <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
              
              
              <!--controls-->  
                     
          </div>
            

            <div class="info-rows modal_quick_actions">
              <h5 class="mt-1 mb-3">Quick Actions</h5>
              <div class="row">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/Download_Preview.png">
                <p>Download Preview</p></a>
                <div class='tooltip'>
                  Download Preview
                  </div>
              </div>
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/Data_Exchange.png">
               <p>Exchange Data</p></a>
               <div class='tooltip'>
                Exchange Data
                </div>
              </div>
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/Custom_Request.png">
                <p>Custom Request</p></a>
                <div class='tooltip'>
                  Custom Request
                  </div>
              </div>
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/Similar.png">
               <p>Similar Ones</p></a>
               <div class='tooltip'>
                Similar Ones
                </div>
              </div>
            </div>

          </div>
            <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7" style="padding-left: 0px;">
          <div class="product-text">
            <h3>Brooklyn Shirt</h3>
            <div class="quickactions">
              <a><img src="../../../assets/image/share.png" ></a>&nbsp;
              <a><img src="../../../assets/image/wishlist.png"></a>
            </div>
            <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">15k</span></i></a></p>
            <div class="row modal-title-price">
              <div class="col-sm-9 modal-price-type">
                <select class="cs-select cs-skin-elastic">
                  <option value="Regular" data-class="Regular" selected>Regular</option>
                  <option value="Extended" data-class="Extended">Extended</option>
                  <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
                </select>
              </div>
              <div class="col-sm-3 price">
               <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
              </div>
             </div>
             <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
             <div class="right_div_background">
              <h5 style="margin-left: 15px;">Purchase Parameters</h5>
              <div class="row attributes">
                <div class="col-sm-3 info-row">
                  <a><img src="../../../assets/image/classification.png">
                  <p>Classification</p></a>
                  <div class='tooltip'>Sensitive</div>
                </div>
                <div class="col-sm-2 info-row">
                  <a><img src="../../../assets/image/data_format.png">
                <p>Data Format</p></a>
                <div class='tooltip'>ZIP</div>
                </div>
                <div class="col-sm-2 info-row">
                  <a><img src="../../../assets/image/data_frequency.png">
                  <p>Data Frequency</p></a>
                  <div class='tooltip'>One-time</div>
                </div>
                <div class="col-sm-2 info-row">
                  <a><img src="../../../assets/image/data_size.png">
                <p>Data Size</p></a>
                <div class='tooltip'>5GB</div>
                </div>
                <div class="col-sm-2 info-row">
                  <a><img src="../../../assets/image/raw_transformed.png">
                <p>Raw</p></a>
                <div class='tooltip'>raw</div>
                </div>
              </div>
             </div>
            <div class="right_div_background">
              <h5 style="margin-left: 15px;">Warranty</h5>
              <div class="row warrantytype">
                <label class="kt-checkbox kt-checkbox--success" >
                  <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                  <span></span>
                </label>
              </div>
              <div class="row warrantytype">
                <label class="kt-checkbox kt-checkbox--success" >
                  <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                  <option value="6">6</option>
                  <option value="12">12</option>
                  <option value="18">18</option>
                  <option value="24">24</option>            
                  </select>months.
                  <span></span>
                </label>
              <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
              </div>    
            </div>
      
         <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
           <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
           <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
         </div>
         </div>
         </div>
    </div>
    </div>
  </div>
  </div>
  </div>



<!--Modal 2-->
<div class="modal fade detailmodal_2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document" style="height: fit-content; width: fit-content;">
<div class="modal-content">
  <a href="" class="modal__close demo-close" data-target="detailmodal_2" data-dismiss="modal">
    <i class="far fa-times-circle"></i>
  </a>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-5 left-side" style="padding-right: 0px;">
        <div id="slider-wrap" class="slider-wrap">
          <ul id="slider" class="slider">
             <li>
               <img src="assets/image/t-shirt.jpg">
             </li>
             
             <li>
              <img src="assets/image/woman.jpg">
             </li>
             
             
          </ul>
          
           <!--controls-->
          <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
          <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
          
          
          <!--controls-->  
                 
      </div>
      
        <div class="info-rows modal_quick_actions">
          <h5 class="mt-1 mb-3">Quick Actions</h5>
          <div class="row">
          <div class="col-sm-3 info-row">
            <a><img src="../../../assets/image/Download_Preview.png">
            <p>Download Preview</p></a>
            <div class='tooltip'>
              Download Preview
              </div>
          </div>
          <div class="col-sm-3 info-row">
            <a><img src="../../../assets/image/Data_Exchange.png">
           <p>Exchange Data</p></a>
           <div class='tooltip'>
            Exchange Data
            </div>
          </div>
          <div class="col-sm-3 info-row">
            <a><img src="../../../assets/image/Custom_Request.png">
            <p>Custom Request</p></a>
            <div class='tooltip'>
              Custom Request
              </div>
          </div>
          <div class="col-sm-3 info-row">
            <a><img src="../../../assets/image/Similar.png">
           <p>Similar Ones</p></a>
           <div class='tooltip'>
            Similar Ones
            </div>
          </div>
        </div>
  
      </div>
      <div class="certificates mt-3">
        <h5 class="mb-3">Content Stamping</h5>
        <div class="row">
          <div class="col-lg-3 col-sm-3 info-row">
           <a><img src="../../../assets/image/complaint_data.png"></a>
           <div class="tooltip">Complaint Data</div>
          </div>
          <div class="col-lg-3 col-sm-3 info-row">
           <a><img src="../../../assets/image/licensed_data.png"></a>
           <div class="tooltip">Licensed Data</div>
          </div>
          <div class="col-lg-3 col-sm-3 info-row">
           <a><img src="../../../assets/image/quality_certified.png"></a>
           <div class="tooltip">Quality Certified</div>
          </div>
          <div class="col-lg-3 col-sm-3 info-row">
           <a><img src="../../../assets/image/verified_sourcing.png"></a>
           <div class="tooltip">Verified Sourcing</div>
          </div>
       </div>
     </div>
      </div>
      <div class="col-lg-7" style="padding-left: 0px;">
      <div class="product-text">
        <h3>Brooklyn Shirt</h3>
        <div class="quickactions">
          <a><img src="../../../assets/image/share.png" ></a>&nbsp;
          <a><img src="../../../assets/image/wishlist.png"></a>
        </div>
        <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
        <div class="row modal-title-price">
          <div class="col-sm-9 modal-price-type">
            <select class="cs-select cs-skin-elastic">
              <option value="Regular" data-class="Regular" selected>Regular</option>
              <option value="Extended" data-class="Extended">Extended</option>
              <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
            </select>
          </div>
          <div class="col-sm-3 price">
           <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
          </div>
         </div>
        <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>

        <div class="right_div_background">
          <h5 style="margin-left: 15px;">Purchase Parameters</h5>
          <div class="row attributes">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/classification.png">
              <p>Classification</p></a>
              <div class='tooltip'>Sensitive</div>
            </div>
            <div class="col-sm-2 info-row">
              <a><img src="../../../assets/image/data_format.png">
            <p>Data Format</p></a>
            <div class='tooltip'>ZIP</div>
            </div>
            <div class="col-sm-2 info-row">
              <a><img src="../../../assets/image/data_frequency.png">
              <p>Data Frequency</p></a>
              <div class='tooltip'>One-time</div>
            </div>
            <div class="col-sm-2 info-row">
              <a><img src="../../../assets/image/data_size.png">
            <p>Data Size</p></a>
            <div class='tooltip'>5GB</div>
            </div>
            <div class="col-sm-2 info-row">
              <a><img src="../../../assets/image/raw_transformed.png">
            <p>Raw</p></a>
            <div class='tooltip'>raw</div>
            </div>
          </div>
         </div>
        <div class="right_div_background">
          <h5 style="margin-left: 15px;">Warranty</h5>
          <div class="row warrantytype">
            <label class="kt-checkbox kt-checkbox--success" >
              <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
              <span></span>
            </label>
          </div>
          <div class="row warrantytype">
            <label class="kt-checkbox kt-checkbox--success" >
              <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
              <option value="6">6</option>
              <option value="12">12</option>
              <option value="18">18</option>
              <option value="24">24</option>            
              </select>months.
              <span></span>
            </label>
          <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
          </div>    
        </div>
     <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
       <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
       <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
     </div>
     </div>
     </div>
</div>
</div>
</div>
</div>
</div>



<!--Modal3-->
<div class="modal fade detailmodal_3" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_3" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>


<!--Modal 4-->
<div class="modal fade detailmodal_4" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_4" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>



<!--Modal 5-->
<div class="modal fade detailmodal_5" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_5" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>



<!--Modal 6-->
<div class="modal fade detailmodal_6" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_6" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>



<!--Modal 7-->
<div class="modal fade detailmodal_7" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_7" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>



<!--Modal 8-->
<div class="modal fade detailmodal_8" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_8" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>




<!--Modal 9-->
<div class="modal fade detailmodal_9" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_9" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>




<!--Modal 10-->
<div class="modal fade detailmodal_10" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_10" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>




<!--Modal 11-->
<div class="modal fade detailmodal_11" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_11" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>



<!--Modal 12-->
<div class="modal fade detailmodal_12" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_12" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>



<!--Modal 13-->
<div class="modal fade detailmodal_13" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <a href="" class="modal__close demo-close" data-target="detailmodal_13" data-dismiss="modal">
      <i class="far fa-times-circle"></i>
    </a>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-5 left-side" style="padding-right: 0px;">
          <div id="slider-wrap" class="slider-wrap">
            <ul id="slider" class="slider">
               <li>
                 <img src="assets/image/t-shirt.jpg">
               </li>
               
               <li>
                <img src="assets/image/woman.jpg">
               </li>
               
               
            </ul>
            
             <!--controls-->
            <div class="btns next" id="next"><i class="fa fa-arrow-right"></i></div>
            <div class="btns previous" id="previous"><i class="fa fa-arrow-left"></i></div>
            
            
            <!--controls-->  
                   
        </div>
          
          <div class="info-rows modal_quick_actions">
            <h5 class="mt-1 mb-3">Quick Actions</h5>
            <div class="row">
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Download_Preview.png">
              <p>Download Preview</p></a>
              <div class='tooltip'>
                Download Preview
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Data_Exchange.png">
             <p>Exchange Data</p></a>
             <div class='tooltip'>
              Exchange Data
              </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Custom_Request.png">
              <p>Custom Request</p></a>
              <div class='tooltip'>
                Custom Request
                </div>
            </div>
            <div class="col-sm-3 info-row">
              <a><img src="../../../assets/image/Similar.png">
             <p>Similar Ones</p></a>
             <div class='tooltip'>
              Similar Ones
              </div>
            </div>
          </div>
        </div>
        <div class="certificates mt-3">
               <h5 class="mb-3">Content Stamping</h5>
               <div class="row">
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/complaint_data.png"></a>
                  <div class="tooltip">Complaint Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/licensed_data.png"></a>
                  <div class="tooltip">Licensed Data</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/quality_certified.png"></a>
                  <div class="tooltip">Quality Certified</div>
                 </div>
                 <div class="col-lg-3 col-sm-3 info-row">
                  <a><img src="../../../assets/image/verified_sourcing.png"></a>
                  <div class="tooltip">Verified Sourcing</div>
                 </div>
              </div>
            </div>
        </div>
        <div class="col-lg-7" style="padding-left: 0px;">
        <div class="product-text">
          <h3>Brooklyn Shirt</h3>
          <div class="quickactions">
            <a><img src="../../../assets/image/share.png" ></a>&nbsp;
            <a><img src="../../../assets/image/wishlist.png"></a>
          </div>
          <p><span class="text-a">Demo text </span><a><i class="fas fa-eye"><span style="font-weight: 400;font-family: MontserratMedium; padding-left: 3px;">   15k</span></i></a></p>
          <div class="row modal-title-price">
            <div class="col-sm-9 modal-price-type">
              <select class="cs-select cs-skin-elastic">
                <option value="Regular" data-class="Regular" selected>Regular</option>
                <option value="Extended" data-class="Extended">Extended</option>
                <option value="Super-Extended" data-class="Super-Extended">Super-Extended</option>
              </select>
            </div>
            <div class="col-sm-3 price">
             <h4 class="btn btn-label-danger btn-sm btn-bold btn-upper">$ 1.119</h4>
            </div>
           </div>
          <span class="infor">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sagittis orci ac odio dictum tincidunt.</span>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Purchase Parameters</h5>
            <div class="row attributes">
              <div class="col-sm-3 info-row">
                <a><img src="../../../assets/image/classification.png">
                <p>Classification</p></a>
                <div class='tooltip'>Sensitive</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_format.png">
              <p>Data Format</p></a>
              <div class='tooltip'>ZIP</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_frequency.png">
                <p>Data Frequency</p></a>
                <div class='tooltip'>One-time</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/data_size.png">
              <p>Data Size</p></a>
              <div class='tooltip'>5GB</div>
              </div>
              <div class="col-sm-2 info-row">
                <a><img src="../../../assets/image/raw_transformed.png">
              <p>Raw</p></a>
              <div class='tooltip'>raw</div>
              </div>
            </div>
           </div>
          <div class="right_div_background">
            <h5 style="margin-left: 15px;">Warranty</h5>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check checked class="regular_ltype">14 days free support for Asset Quality.
                <span></span>
              </label>
            </div>
            <div class="row warrantytype">
              <label class="kt-checkbox kt-checkbox--success" >
                <input type="checkbox" name='check' [ngModel] #check required class="regular_ltype">Additional support for<select name="warranty-time" class="warrantytime">
                <option value="6">6</option>
                <option value="12">12</option>
                <option value="18">18</option>
                <option value="24">24</option>            
                </select>months.
                <span></span>
              </label>
            <span class="warrantyprice btn btn-label-danger btn-sm btn-bold btn-upper">${{warrantyprice}}</span>
            </div>    
          </div>
       <div class="add-cart-btns row" style="margin-left:0px ; margin-right: 0px;">
         <a class="btn1" style="color: white;" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Add To cart</a>
         <a class="btn2" routerLink="/addcart" data-target="detailmodal" data-dismiss="modal">Buy Now</a>
       </div>
       </div>
       </div>
  </div>
  </div>
</div>
</div>
</div>